<template>
<div v-if="field">
<span class="fas fa-map-marker-alt"></span>
<span v-if="field.zip">{{ field.zip }} </span>
<span v-if="field.city && field.district">{{ field.city }}–{{ field.district }}</span>
<span v-else-if="field.city">{{ field.city }}</span>
<span v-if="field.radius">
<br>
{{ $t("Umkreis") }}: {{ field.radius }}&nbsp;km
</span>
</div>
</template>

<script>
export default {
  name: "LocationField",

  props: [
    "field"
  ]
}
</script>
